export const fingerprintEndpoint = 'https://mwl.x89cpjvc2banzai.com';
